/* ============================================================
   Partnerbereiche gesund leben und Alliance Healthcare / GEHE
   (Stand 05.10.2026, Entscheidungen Sales).

   MUSS nach theme.js, gc-adapter-freebie.js, gc-aposanitas.js und
   gc-dental.js geladen werden: legt sich um gcEnforceMengenrabatt()
   und gcEnforcePosFreebie().

   Konfiguration (Codes, Saetze, Texte, Logos, Varianten-IDs) steht in
   snippets/gc-partner-mode.liquid (window.gcPartners / gcPartnerShared).

   Partnermodus = Warenkorb-Attribut partner_flow (gesundleben | ahd),
   gesetzt NUR beim Direktaufruf von /pages/gesundleben bzw. /pages/ahd
   (sections/partner-configurator.liquid). Aposanitas- oder Dental-Modus
   haben Vorrang und beenden den Partnermodus.

   Im Partnermodus:
   - Mit Igloo Reader Pro DC: Partnercode (GESUNDLEBEN20 bzw. AHD15),
     ggf. zusaetzlich der 0-%-Collabs-Code. Staffel-, Starterkit-,
     Aposanitas- und Dental-Codes werden entfernt.
   - Testkits werden aus dem Warenkorb entfernt (Bezug ueber Alliance
     Healthcare / GEHE).
   - POS: ein Paket kostenlos schon mit dem Geraet (ohne Testbox-Minimum).
   - Adapter: alle vier + QC-Kassette ueber gc-adapter-freebie.js. Der
     Konsung-Adapter gilt seit 05.10.2026 im GANZEN Shop kostenlos zum
     Igloo Reader Pro DC und ist nicht nachbestellbar - die Regel steht
     nur noch in gc-adapter-freebie.js, hier gibt es keine Sonderlogik mehr.
   - Warenkorb: Hinweisbox, lesbare Rabattzeile, Pflicht-Bestaetigung.
   - Navigation: Neukund:innen/Starterkit -> Partner-Rechner,
     Bestandskund:innen -> Zubehoer.
   - Igloo Reader Pro DC: Produktseite und Kacheln zeigen den
     rabattierten Preis mit Hinweis auf den Partnerrabatt.
   Ausserhalb des Modus werden die Partnercodes entfernt.

   GEBIETSLEITUNG (gesund leben seit 21.10.2026, Alliance Healthcare /
   GEHE seit 22.10.2026, Entscheidungen Sales):
   Hat ein Partner in der Konfiguration ein Feld "region", greift der
   Partnercode erst, wenn im Warenkorb der Name der zustaendigen
   Gebietsleitung bei Alliance Healthcare / GEHE eingetragen ist
   (Warenkorb-Attribut region.attr, landet an der Bestellung). Vorher
   zeigt der Warenkorb den Rabatt als Vorschau mit Betrag. Inhaltlich
   wird nichts geprueft - es muss nur etwas drinstehen. Mit DC im
   Warenkorb ist das Feld Pflicht (Auschecken gesperrt, wie die
   Bestaetigungs-Haken).
   ============================================================ */
(function(){
  'use strict';

  var P = window.gcPartners || {};
  var S = window.gcPartnerShared || {};
  var STAFFEL = ['NACHBESTELLUNG5', 'NACHBESTELLUNG10', 'STARTERKIT2026',
                 'STARTERKITDENTAL', 'DENTALSTARTERKIT20',
                 'APOSANITAS20', 'APOSANITAS15', 'APOSANITAS10'];

  function root(){
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function up(c){ return String(c || '').toUpperCase(); }

  function ownCodes(){
    var list = [];
    Object.keys(P).forEach(function(k){
      if(P[k].code) list.push(up(P[k].code));
      if(P[k].collabsCode) list.push(up(P[k].collabsCode));
    });
    return list;
  }
  function partnerAttrs(){
    return Object.keys(P).map(function(k){ return P[k].attr; });
  }
  /* Attribut-Namen der Gebietsleitungs-Felder aller Partner */
  function regionAttrs(){
    var list = [];
    Object.keys(P).forEach(function(k){
      if(P[k].region && P[k].region.attr && list.indexOf(P[k].region.attr) === -1) list.push(P[k].region.attr);
    });
    return list;
  }
  /* Braucht der Partner keine Gebietsleitung oder ist sie eingetragen? */
  function regionOk(C, attrs){
    if(!C.region) return true;
    return String((attrs || {})[C.region.attr] || '').trim() !== '';
  }

  /* Partner-Schluessel aus den Warenkorb-Attributen (oder null). */
  function modeKey(attrs){
    attrs = attrs || {};
    if(attrs.aposanitas_flow === 'true' || attrs.dental_flow === 'true') return null;
    var k = attrs.partner_flow;
    return (k && P[k]) ? k : null;
  }
  window.gcPartnerModeKey = modeKey;

  async function getCart(){
    var res = await fetch(root() + 'cart.js');
    return res.json();
  }
  async function postUpdate(body){
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body)
    });
  }

  /* ------------------------------------------------------------
     Rabattcodes, Attribute, Testkits
     ------------------------------------------------------------ */
  async function gcEnforcePartner(){
    try{
      var cart = await getCart();
      var attrs = cart.attributes || {};
      var key = modeKey(attrs);
      var current = (cart.discount_codes || []).map(function(d){ return d.code; });
      var own = ownCodes();
      var isOwn = function(c){ return own.indexOf(up(c)) !== -1; };

      if(!key){
        var body0 = {};
        if(current.some(isOwn)) body0.discount = current.filter(function(c){ return !isOwn(c); }).join(',');
        /* Partnerkennung entfernen, wenn Aposanitas/Dental uebernommen hat */
        if(attrs.partner_flow){
          body0.attributes = { partner_flow: '' };
          if(partnerAttrs().indexOf(attrs.Partner) !== -1) body0.attributes.Partner = '';
        }
        regionAttrs().forEach(function(a){
          if(attrs[a]){ body0.attributes = body0.attributes || {}; body0.attributes[a] = ''; }
        });
        if(body0.discount !== undefined || body0.attributes){
          await postUpdate(body0);
          if(typeof gcRefreshCartSection === 'function') await gcRefreshCartSection();
        }
        return;
      }

      var C = P[key];

      /* Testkits sind im Partnerbereich nicht bestellbar */
      var testLines = cart.items.filter(function(i){ return i.product_type === 'Testkit'; });
      if(testLines.length){
        var upd = {};
        testLines.forEach(function(i){ upd[i.key] = 0; });
        await postUpdate({ updates: upd });
        if(typeof gcShowError === 'function'){
          gcShowError('Testkits beziehen Sie über Alliance Healthcare / GEHE. Sie wurden aus dem Warenkorb entfernt.');
        }
        cart = await getCart();
        current = (cart.discount_codes || []).map(function(d){ return d.code; });
      }

      var dcQty = 0;
      cart.items.forEach(function(i){ if(i.variant_id === S.dcVariantId) dcQty += i.quantity; });

      window.__gcpCart = cart;

      var target = [];
      if(dcQty >= 1 && regionOk(C, attrs)) target.push(C.code);
      if(C.collabsCode) target.push(C.collabsCode);
      var rest = current.filter(function(c){ return !isOwn(c) && STAFFEL.indexOf(up(c)) === -1; });
      var desired = target.concat(rest);

      var body = {};
      var same = desired.length === current.length && desired.every(function(c){ return current.indexOf(c) !== -1; });
      if(!same) body.discount = desired.join(',');
      if(attrs.Partner !== C.attr || attrs.startbonus_flow){
        body.attributes = { partner_flow: key, Partner: C.attr, startbonus_flow: '' };
      }
      regionAttrs().forEach(function(a){
        if(C.region && C.region.attr === a) return;
        if(attrs[a]){ body.attributes = body.attributes || {}; body.attributes[a] = ''; }
      });
      if(body.discount === undefined && !body.attributes){
        if(testLines.length && typeof gcRefreshCartSection === 'function') await gcRefreshCartSection();
        if(typeof window.gcPartnerDecorate === 'function') window.gcPartnerDecorate();
        return;
      }
      await postUpdate(body);
      if(typeof gcRefreshCartSection === 'function') await gcRefreshCartSection();
      if(typeof gcUpdateCartBadge === 'function') await gcUpdateCartBadge();
    } catch(err){
      console.error('Partner-Check fehlgeschlagen:', err);
    }
  }
  window.gcEnforcePartner = gcEnforcePartner;

  (function(){
    var orig = window.gcEnforceMengenrabatt;
    window.gcEnforceMengenrabatt = async function(){
      if(typeof orig === 'function') await orig.apply(this, arguments);
      await gcEnforcePartner();
    };
  })();

  /* ------------------------------------------------------------
     POS: im Partnermodus kostenlos schon mit dem Geraet.
     Adapter (inkl. Konsung zum DC) regelt gc-adapter-freebie.js.
     ------------------------------------------------------------ */
  (function(){
    var origPos = window.gcEnforcePosFreebie;
    window.gcEnforcePosFreebie = async function(){
      try{
        var cart = await getCart();
        var key = modeKey(cart.attributes);

        if(!key){
          if(typeof origPos === 'function') await origPos.apply(this, arguments);
          return;
        }

        var deviceQty = 0;
        var qtyByVariant = {};
        cart.items.forEach(function(i){
          if(i.product_type === 'Geraet') deviceQty += i.quantity;
          qtyByVariant[i.variant_id] = (qtyByVariant[i.variant_id] || 0) + i.quantity;
        });

        var updates = (typeof gcPosTargetUpdates === 'function') ? gcPosTargetUpdates(qtyByVariant, deviceQty >= 1) : {};

        if(Object.keys(updates).length){
          var r = await postUpdate({ updates: updates });
          if(!r.ok) throw new Error('cart/update.js ' + r.status);
        }
        if(typeof window.gcEnforceAdapterFreebie === 'function') await window.gcEnforceAdapterFreebie();
        if(Object.keys(updates).length && typeof gcRefreshCartSection === 'function') await gcRefreshCartSection();
      } catch(err){
        console.error('Partner-POS/Adapter-Check fehlgeschlagen:', err);
      }
    };
  })();

  /* ------------------------------------------------------------
     Verlassen
     ------------------------------------------------------------ */
  window.gcPartnerLeave = async function(){
    try{ sessionStorage.removeItem('gcp_session'); sessionStorage.removeItem('gcp_open_tried'); }catch(e){}
    try{
      var cart = await getCart();
      var own = ownCodes();
      var rest = (cart.discount_codes || []).map(function(d){ return d.code; })
        .filter(function(c){ return own.indexOf(up(c)) === -1; });
      var clear = { partner_flow: '', Partner: '' };
      regionAttrs().forEach(function(a){ clear[a] = ''; });
      await postUpdate({ discount: rest.join(','), attributes: clear });
    }catch(e){}
    window.location.href = root();
  };

  /* ------------------------------------------------------------
     Seite im Partnermodus anpassen (Navigation, Testkit-Seiten, Warenkorb)
     ------------------------------------------------------------ */
  var KEY = window.gcPartnerKey && P[window.gcPartnerKey] ? window.gcPartnerKey : null;
  if(!KEY) return;
  var CFG = P[KEY];

  function pathOf(a){
    try{ return new URL(a.getAttribute('href'), window.location.origin).pathname.replace(/\/$/, ''); }catch(e){ return ''; }
  }

  function rewriteNav(){
    var onPartnerPage = window.location.pathname.replace(/\/$/, '') === CFG.page;
    var neu = document.getElementById('nav-neukunden');
    if(neu){
      neu.setAttribute('href', CFG.page);
      if(onPartnerPage) neu.classList.add('active');
    }
    var best = document.getElementById('nav-bestandskunden');
    if(best) best.setAttribute('href', '/pages/zubehor');
    document.querySelectorAll('a[href]').forEach(function(a){
      var p = pathOf(a);
      if(p === '/pages/igloo-starterkit' || p === '/pages/igloo-startbonus'){
        a.setAttribute('href', CFG.page);
        if(a.classList.contains('sub-pill')) a.textContent = 'Igloo Starterkit';
      }
      if(p === '/pages/bestandskund-innen') a.setAttribute('href', '/pages/zubehor');
    });
  }

  function testkitNotice(){
    var tpl = document.getElementById('gcp-testkit-notice');
    var info = document.querySelector('.product-info');
    if(!tpl || !info || info.querySelector('.gcp-testkit-notice')) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    var slot = node.querySelector('.gcp-ahd-link');
    if(slot){
      if(S.ahdShopUrl){
        var a = document.createElement('a');
        a.href = S.ahdShopUrl; a.target = '_blank'; a.rel = 'noopener';
        a.className = 'btn btn-navy';
        a.textContent = 'Zum Shop von Alliance Healthcare / GEHE';
        slot.appendChild(a);
      } else {
        slot.remove();
      }
    }
    var form = info.querySelector('form[action*="/cart/add"]');
    if(form) info.insertBefore(node, form); else info.appendChild(node);
  }

  /* Rabattierten Geraetepreis zeigen: Produktseite des Igloo Reader Pro DC
     und Kacheln, die auf den DC verlinken. Abgezogen wird der Rabatt
     weiterhin erst im Warenkorb (Partnercode). */
  var DC_PATH = '/products/gc-igloo-reader-pro-dc';
  var PRICE_LABEL = CFG.rate + '\u00a0% ' + (KEY === 'ahd' ? 'Alliance Healthcare-Rabatt' : 'gesund leben-Rabatt');
  function eur(n){ return '€ ' + n.toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2}); }
  function parseEur(t){ var v = parseFloat(String(t).replace(/[^\d,]/g, '').replace(',', '.')); return isNaN(v) ? 0 : v; }
  function discounted(p){ return Math.round(p * (100 - CFG.rate)) / 100; }

  function partnerPrices(){
    if(window.location.pathname.replace(/\/$/, '') === DC_PATH){
      var el = document.querySelector('.product-info .price-row .price');
      if(el && !el.dataset.gcp){
        var p = parseEur(el.textContent);
        if(p > 0){
          el.dataset.gcp = '1';
          el.textContent = eur(discounted(p));
          var old = document.createElement('s');
          old.textContent = eur(p);
          old.style.cssText = 'color:var(--muted);font-size:.55em;font-weight:500;margin-left:10px;';
          el.parentNode.insertBefore(old, el.nextSibling);
          var note = document.createElement('div');
          note.className = 'gcp-price-note';
          note.style.cssText = 'display:inline-block;font-size:12.5px;font-weight:600;line-height:1.4;color:var(--navy);background:var(--ice-light);border-radius:8px;padding:7px 11px;margin:-6px 0 20px;';
          note.textContent = PRICE_LABEL + ' – ' + (CFG.priceNote || 'wird im Warenkorb automatisch abgezogen.');
          var unit = el.closest('.product-info').querySelector('.price-unit');
          var anchor = unit || el.closest('.price-row');
          anchor.parentNode.insertBefore(note, anchor.nextSibling);
        }
      }
    }
    document.querySelectorAll('.card').forEach(function(card){
      var link = card.querySelector('a[href*="' + DC_PATH + '"]');
      var oc = card.getAttribute('onclick') || '';
      if(!link && oc.indexOf(DC_PATH) === -1) return;
      var cp = card.querySelector('.card-price');
      if(!cp || cp.dataset.gcp) return;
      var p = parseEur(cp.textContent);
      if(!(p > 0)) return;
      cp.dataset.gcp = '1';
      cp.innerHTML = '';
      cp.appendChild(document.createTextNode(eur(discounted(p)) + ' '));
      var s = document.createElement('s');
      s.textContent = eur(p);
      s.style.cssText = 'color:var(--muted);font-size:.7em;font-weight:500;';
      cp.appendChild(s);
      var n = document.createElement('div');
      n.style.cssText = 'font-size:11.5px;font-weight:600;color:var(--navy);margin-top:2px;';
      n.textContent = PRICE_LABEL;
      cp.parentNode.insertBefore(n, cp.nextSibling);
    });
  }

  /* Partner-Rechner: Fussnote ggf. ersetzen (z. B. Hinweis Gebietsleitung) */
  function rechnerNote(){
    if(!CFG.rechnerNote) return;
    var p = document.querySelector('#gcp-root #gcp-order-btn + p');
    if(p && p.dataset.gcp !== '1'){ p.dataset.gcp = '1'; p.textContent = CFG.rechnerNote; }
  }

  /* ------------------------------------------------------------
     Gebietsleitung (nur Partner mit CFG.region, derzeit gesund leben)
     ------------------------------------------------------------ */
  var R = CFG.region || null;
  var regionValue = null;      /* null = noch nichts getippt, Wert aus dem Warenkorb */
  var regionSaved = null;      /* zuletzt gespeicherter Wert */
  var regionTimer = null;
  var regionFocus = false;
  var regionBusy = false;
  var regionPending = false;   /* getippt, aber noch nicht gespeichert */

  function regionStored(){
    var c = window.__gcpCart;
    return (c && c.attributes && R) ? String(c.attributes[R.attr] || '') : '';
  }
  function regionCurrent(){ return regionValue !== null ? regionValue : regionStored(); }
  function dcSavings(){
    var c = window.__gcpCart;
    if(!c || !c.items) return 0;
    var cents = 0;
    c.items.forEach(function(i){ if(i.variant_id === S.dcVariantId) cents += i.original_line_price; });
    return Math.round(cents * CFG.rate / 100) / 100;
  }
  function esc(t){
    return String(t).replace(/[&<>"]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; });
  }

  async function saveRegion(){
    clearTimeout(regionTimer);
    var val = regionCurrent().trim();
    if(regionSaved === null) regionSaved = regionStored().trim();
    if(val === regionSaved){ regionPending = false; decorateCart(); return; }
    regionBusy = true;
    decorateCart();
    try{
      var a = {}; a[R.attr] = val;
      var r = await postUpdate({ attributes: a });
      if(r.ok){
        regionSaved = val;
        if(window.__gcpCart && window.__gcpCart.attributes) window.__gcpCart.attributes[R.attr] = val;
      }
      await gcEnforcePartner();
    }catch(e){
      console.error('Gebietsleitung konnte nicht gespeichert werden:', e);
    }
    regionBusy = false;
    regionPending = false;
    decorateCart();
  }

  function injectRegionCss(){
    if(document.getElementById('gcp-region-css')) return;
    var st = document.createElement('style');
    st.id = 'gcp-region-css';
    st.textContent =
      '.gcp-region{flex-basis:100%;background:var(--ice-light,#EAF4FA);border-radius:10px;padding:14px 16px;margin-top:4px;}' +
      '.gcp-region label{display:block;font-size:13.5px;font-weight:700;color:var(--navy);margin:0 0 7px;}' +
      '.gcp-region label .gcp-req{color:var(--sale,#B00020);font-weight:600;margin-left:2px;}' +
      '.gcp-region-row{display:flex;align-items:center;flex-wrap:wrap;gap:8px 12px;}' +
      '.gcp-region input{flex:1 1 240px;max-width:380px;min-width:0;box-sizing:border-box;border:1px solid var(--border);border-radius:999px;padding:10px 16px;font-family:inherit;font-size:13.5px;color:var(--text);background:#fff;transition:border-color .15s ease;}' +
      '.gcp-region input:focus{outline:none;border-color:var(--navy);box-shadow:0 0 0 3px rgba(79,168,214,.25);}' +
      '.gcp-region-state{font-size:12.5px;font-weight:600;color:var(--muted);}' +
      '.gcp-region-state.is-ok{color:#2C6B4F;}' +
      '.gcp-region p{font-size:12px;line-height:1.55;color:var(--muted);margin:8px 0 0;}' +
      '.gcp-save{display:inline-block;font-weight:700;color:var(--navy);white-space:nowrap;}';
    document.head.appendChild(st);
  }

  /* Warenkorb: Box, Rabattzeile, Gutschein-Chip, Gebietsleitung,
     Pflicht-Bestaetigung. Rein aus dem DOM, damit es nach jedem Neuaufbau
     sofort wieder steht. */
  var consentChecked = false;
  function decorateCart(){
    var rootEl = document.getElementById('gc-cart-section-content');
    if(!rootEl) return;
    var code = up(CFG.code);
    var hidden = [code];
    if(CFG.collabsCode) hidden.push(up(CFG.collabsCode));

    var applied = false;
    rootEl.querySelectorAll('.pb-row.pb-discount > span:first-child').forEach(function(s){
      var t = up(s.textContent.trim());
      if(t === code){
        s.textContent = CFG.label;
        applied = true;
      } else if(s.dataset.gcpLabel === '1'){
        applied = true;
      }
      if(t === code) s.dataset.gcpLabel = '1';
    });

    rootEl.querySelectorAll('.gc-voucher-chip').forEach(function(chip){
      var t = up(chip.textContent);
      if(hidden.some(function(h){ return t.indexOf(h) !== -1; })) chip.style.display = 'none';
    });

    /* cart-line.liquid hat keinen Produktlink - Erkennung ueber den Titel */
    var hasDc = applied || Array.prototype.some.call(
      rootEl.querySelectorAll('#cart-items-list .cart-item-info h4'),
      function(h){ return /Reader Pro DC\s*$/.test(h.textContent.trim()); }
    );

    var needRegion = !!R && hasDc;
    var regionVal = needRegion ? regionCurrent().trim() : '';
    var save = dcSavings();
    var saveTxt = save > 0 ? ' Sie sparen <span class="gcp-save">' + eur(save) + '</span>.' : '';

    var breakdown = rootEl.querySelector('.price-breakdown');
    var box = rootEl.querySelector('.gcp-cart');
    var msg, state;
    if(!hasDc){
      state = 'nodc';
      msg = '<strong style="color:var(--navy);">' + CFG.cond + ' gelten zusammen mit dem Igloo Reader Pro DC.</strong>';
    } else if(applied){
      state = 'on';
      msg = '<strong style="color:var(--navy);">' + CFG.cond + ' sind aktiv</strong> – ' + CFG.rate + '\u00a0% auf den Igloo Reader Pro DC, Adapter und POS-Paket kostenlos. Automatisch abgezogen, kein Code nötig.';
    } else if(needRegion && regionVal && !regionBusy && !regionPending && regionSaved === regionVal){
      /* gespeichert, aber Shopify hat den Code nicht angenommen */
      state = 'fail';
      msg = '<strong style="color:var(--navy);">Ihr ' + (CFG.brand || CFG.name) + '-Rabatt konnte gerade nicht übernommen werden.</strong> Bitte laden Sie die Seite neu oder <a href="/pages/kontakt" style="color:var(--navy);text-decoration:underline;">kontaktieren Sie uns</a>.';
    } else if(needRegion && (regionBusy || regionPending || regionVal)){
      state = 'wait';
      msg = '<strong style="color:var(--navy);">Ihr ' + (CFG.brand || CFG.name) + '-Rabatt wird übernommen …</strong>' + saveTxt;
    } else if(needRegion){
      state = 'preview';
      msg = '<strong style="color:var(--navy);">Ihr ' + (CFG.brand || CFG.name) + '-Vorteil: ' + CFG.rate + '\u00a0% auf den Igloo Reader Pro DC.</strong>' + saveTxt +
        '<br>Es fehlt nur noch ein Schritt: Tragen Sie unten Ihre Gebietsleitung ein, dann ziehen wir den Rabatt sofort ab.';
    } else {
      state = 'off';
      msg = '<strong style="color:var(--navy);">' + CFG.cond + ':</strong> Der Rabatt auf den Igloo Reader Pro DC gilt einmal pro Apotheke. Fragen? <a href="/pages/kontakt" style="color:var(--navy);text-decoration:underline;">Kontakt</a>';
    }
    state += '|' + save;

    if(breakdown){
      if(!box){
        box = document.createElement('div');
        box.className = 'gcp-cart';
        if(!R) box.setAttribute('role', 'status');
        box.style.cssText = 'display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px 16px;border:1.5px solid var(--ice, #4FA8D6);border-radius:12px;padding:11px 16px;margin:18px 0 6px;background:#fff;font-size:13px;line-height:1.5;color:var(--text);';
        box.innerHTML = '<span style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;flex:1 1 320px;"><img src="' + CFG.logo + '" alt="' + CFG.name + '" width="110" style="display:block;width:110px;height:auto;"><span class="gcp-cart-msg"' + (R ? ' role="status" aria-live="polite"' : '') + ' style="flex:1 1 220px;"></span></span>' +
          '<a href="' + CFG.page + '" style="font-size:12.5px;font-weight:600;color:var(--navy);text-decoration:underline;text-underline-offset:2px;">Zum Partner-Rechner</a>';
        breakdown.parentNode.insertBefore(box, breakdown);
      }
      var m = box.querySelector('.gcp-cart-msg');
      if(m && m.dataset.state !== state){ m.dataset.state = state; m.innerHTML = msg; }

      /* Eingabefeld Gebietsleitung */
      var reg = box.querySelector('.gcp-region');
      if(needRegion && !reg){
        injectRegionCss();
        reg = document.createElement('div');
        reg.className = 'gcp-region';
        reg.innerHTML =
          '<label for="gcp-region-input">' + esc(R.label) + '<span class="gcp-req" aria-hidden="true">*</span></label>' +
          '<div class="gcp-region-row">' +
            '<input type="text" id="gcp-region-input" autocomplete="off" maxlength="120" aria-required="true" aria-describedby="gcp-region-hint" placeholder="' + esc(R.placeholder || '') + '">' +
            '<span class="gcp-region-state" aria-hidden="true"></span>' +
          '</div>' +
          '<p id="gcp-region-hint">' + esc(R.hint || '') + '</p>';
        var inp = reg.querySelector('input');
        inp.value = regionCurrent();
        inp.addEventListener('focus', function(){ regionFocus = true; });
        inp.addEventListener('blur', function(){ if(inp.isConnected) regionFocus = false; });
        inp.addEventListener('input', function(){
          regionValue = inp.value;
          regionPending = true;
          var mirror = document.getElementById('gcp-region-value');
          if(mirror) mirror.value = inp.value.trim();
          decorateCart();
          clearTimeout(regionTimer);
          regionTimer = setTimeout(saveRegion, 800);
        });
        inp.addEventListener('change', saveRegion);
        inp.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); saveRegion(); } });
        box.appendChild(reg);
        if(regionFocus){
          inp.focus();
          try{ inp.setSelectionRange(inp.value.length, inp.value.length); }catch(e){}
        }
      } else if(!needRegion && reg){
        reg.remove();
      }
      if(reg && needRegion){
        var st = reg.querySelector('.gcp-region-state');
        var stTxt = applied ? '✓ Rabatt aktiv' : ((regionBusy || regionPending || (regionVal && regionSaved !== regionVal)) ? 'wird übernommen …' : '');
        if(st && st.textContent !== stTxt){
          st.textContent = stTxt;
          st.classList.toggle('is-ok', applied);
        }
      }
    }

    var form = rootEl.querySelector('#gc-checkout-form');
    var btn = rootEl.querySelector('#checkout-btn');

    /* Gebietsleitung mit dem Checkout-POST an die Bestellung (mirror) und
       als Pflichtangabe fuer gcAllConsentsChecked()/gcCheckoutGuard() in
       main-cart.liquid (gate): das Gate zaehlt als "abgehakt", sobald im
       Feld etwas steht, und leitet den Fokus ans sichtbare Feld weiter.
       Das Gate hat KEIN name-Attribut, damit gcStampConsent() nichts
       hineinschreibt. */
    var mirror = rootEl.querySelector('#gcp-region-value');
    var gate = rootEl.querySelector('#gcp-region-gate');
    if(form && btn && needRegion){
      if(!mirror){
        mirror = document.createElement('input');
        mirror.type = 'hidden';
        mirror.id = 'gcp-region-value';
        mirror.name = 'attributes[' + R.attr + ']';
        form.insertBefore(mirror, form.firstChild);
      }
      if(mirror.value !== regionVal) mirror.value = regionVal;
      if(!gate){
        gate = document.createElement('input');
        gate.type = 'hidden';
        gate.id = 'gcp-region-gate';
        gate.className = 'gc-required-consent';
        Object.defineProperty(gate, 'checked', { configurable: true, get: function(){
          var f = document.getElementById('gcp-region-input');
          return !!f && f.value.trim() !== '';
        }});
        gate.focus = function(){
          var f = document.getElementById('gcp-region-input');
          if(!f) return;
          try{ f.scrollIntoView({ block: 'center', behavior: 'smooth' }); }catch(e){}
          f.focus();
        };
        form.insertBefore(gate, form.firstChild);
      }
    } else {
      if(mirror) mirror.remove();
      if(gate) gate.remove();
    }

    var existing = rootEl.querySelector('#cart-consent-partner');
    if(form && btn && applied && !existing){
      var row = document.createElement('div');
      row.className = 'consent-row';
      row.innerHTML = '<input type="checkbox" id="cart-consent-partner" class="gc-required-consent" value="Ja, bestätigt">' +
        '<label for="cart-consent-partner"></label>';
      var input = row.querySelector('input');
      input.name = 'attributes[' + CFG.consentName + ']';
      input.checked = consentChecked;
      input.addEventListener('change', function(){
        consentChecked = input.checked;
        if(typeof gcUpdateCheckoutBtn === 'function') gcUpdateCheckoutBtn();
      });
      row.querySelector('label').textContent = CFG.consentText;
      form.insertBefore(row, btn);
    } else if(existing && !applied){
      existing.closest('.consent-row').remove();
    }
    if(typeof gcUpdateCheckoutBtn === 'function') gcUpdateCheckoutBtn();
  }
  window.gcPartnerDecorate = decorateCart;

  document.addEventListener('DOMContentLoaded', function(){
    rewriteNav();
    testkitNotice();
    partnerPrices();
    rechnerNote();
    var rootEl = document.getElementById('gc-cart-section-content');
    if(rootEl){
      decorateCart();
      if(R){
        getCart().then(function(c){ window.__gcpCart = c; decorateCart(); }).catch(function(){});
      }
      if(window.MutationObserver){
        var pending = false;
        new MutationObserver(function(){
          if(pending) return;
          pending = true;
          requestAnimationFrame(function(){ pending = false; decorateCart(); });
        }).observe(rootEl, { childList: true, subtree: true });
      }
    }
  });
})();
